import { useMemo } from 'react';

import { useGetDriversQuery } from '#api/resources.slice.ts';

export const useGetDriverOptions = () => {
    const { data: drivers } = useGetDriversQuery();
    return useMemo(
        () =>
            drivers?.map(driver => ({
                id: driver.id,
                label: driver.name,
            })) || [],
        [drivers]
    );
};
